// 面談予約情報に関する共通処理を定義

import { executeGetInterview } from '../../dataAccess/webApi/dao/interviewsDao'
import { fromApiYmd, fromApiYmdHms, endOfDay, getNow, ElapsedMillisecond } from '../../utils/dateUtil'
import { nullPropsToUndefined } from '../../utils/objectUtil'
import { yesNo } from './constant/classification'

export type DocType = {
  fileName: string | null
  delFlg: string | null
  tempUploadKey: string | null
}

export type TempFile = {
  files: DocType[]
  hasSubmitted: string
  status?: string
}

export type FacilityInputDetail = {
  id: string | null
  answer: string
  updateDatetime: string | null
  facilityInterviewInputFieldId?: number
  order: number | null
}

type child = {
  childId: string
  childName: string
  childKana: string
  childGender: string
  childBirthday: ElapsedMillisecond
  childMedicalHistoryFlag: string
  childMedicalHistory: string
  childAllergyFlag: string
  childAllergy: string
  //TODO：HOIKU-178にて暫定的に母子健康手帳の項目を非表示＆登録されないようにする
  //maternalHandbookNo: string
  note: string
  facilityNumber: string
  childUpdateDatetime: string
  childInterviewPermitCount: number
  availabilityOfApplication: string
  tempFile?: TempFile
  facilityInputFields?: { [key: string]: FacilityInputDetail }
}

export const setStringifyNamesChildInfoList = <T extends child>(childInfoList: T[]): T[] => {
  return childInfoList.map((childInfo) => {
    const returnChildInfo = { ...childInfo };

    // 書類
    if (childInfo.tempFile) {
      returnChildInfo.tempFile = {
        ...childInfo.tempFile,
      };
      // なぜ必要なのか不明 利用予約では不要
      returnChildInfo.tempFile.files = childInfo.tempFile.files.map((file) => {
        return { ...file }
      })
    }

    // 任意項目
    if (childInfo.facilityInputFields) {
      returnChildInfo.facilityInputFields = {
        ...childInfo.facilityInputFields,
      }
    }

    return returnChildInfo
  })
}

/**
 * 指定した受付Noの面談予約情報を返す。
 *
 * @param interviewNo 受付No
 * @returns 面談予約情報
 */
export const getInterview = async (interviewNo: string) => {
  const response = await executeGetInterview(interviewNo)
  const {
    interviewDate,
    interviewStartDatetime,
    interviewEndDatetime,
    childBirthday,
    canUpdate,
    canCancel,
    reservationDatetime,
    reservationChangeDatetime,
    reservationCancelDatetime,
    ...other
  } = response.result

  // 添付ファイルの有無
  const hasTempDoc = !!other.tempDoc1Name || !!other.tempDoc2Name || !!other.tempDoc3Name || !!other.tempDoc4Name || !!other.tempDoc5Name

  return nullPropsToUndefined({
    ...other,
    interviewNo,
    interviewDate: fromApiYmd(interviewDate),
    interviewStartDatetime: fromApiYmdHms(interviewStartDatetime),
    interviewEndDatetime: fromApiYmdHms(interviewEndDatetime),
    childBirthday: fromApiYmd(childBirthday),
    canUpdate: canUpdate === yesNo.yes,
    canCancel: canCancel === yesNo.yes,
    canCancelWait: interviewDate && getNow().getTime() <= endOfDay(interviewDate).getTime(),
    reservationDatetime: fromApiYmdHms(reservationDatetime),
    reservationChangeDatetime: fromApiYmdHms(reservationChangeDatetime),
    reservationCancelDatetime: fromApiYmdHms(reservationCancelDatetime),
    hasTempDoc: hasTempDoc ? yesNo.yes : yesNo.no
  })
}

/** 面談予約情報の型 */
export type Interview = ReturnType<typeof getInterview> extends Promise<infer T> ? T : never
